import { useEffect } from "react";
import { getClubs } from "../../js/database";
import { generateSchedule } from "../../js/generateSchedule";
import { useSelector } from "react-redux";

export default function Alarm() {
    const user = useSelector(state => state.database); 
        
    return (
        <div>
            <div class="modal fade" id="alarm" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog">
                    <div class="modal-content bg-dark">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">Set Your Alarm (Experimental)</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <p>With the cyclic schedule, setting alarms can be tough. Skilldule has an included Alarm functionality for iOS devices.</p>
                            <p className="text-warning">Note: this only works on cycle days.</p>
                            <ol>
                                <li>1. Download the Shortcut <a href="https://www.icloud.com/shortcuts/1fd263bde60d45d6a13cbbc1e4bfb206" download={true}>here</a>.</li>
                            <li>2. Copy your starting times by clicking this button:</li>
                            <div class="text-center codeBtn mt-2 mb-2"><button class="btn btn-primary" onClick={() => {
  var userCopy = JSON.parse(JSON.stringify(user));
  if (!userCopy.settings) userCopy.settings = {};
  userCopy.settings.fCycle = true;
  userCopy.settings.wschedule = false;

getClubs().then((clubs) => {
    generateSchedule(userCopy, clubs).then((schedule) => {
        var startTimes = schedule.map((d) => d.schedule[0].time[0]);
            var startTimeDict = {}
            startTimes.forEach((d, i) => {
              startTimeDict[String(i+1)] = d;
            })
  try {
    navigator.clipboard.writeText(JSON.stringify(startTimeDict)).then(function() {
      document.getElementById("copyAlarm").innerText = "Copied!"
      document.getElementById("copyAlarm").classList.remove("btn-primary")
      document.getElementById("copyAlarm").classList.add("btn-success")
    }, function(err) {
      console.error("Async: Could not copy text ", err);;
    })
  } catch (err) {
  //  document.getElementById("code").classList.remove("hidden")
  }
})
})
  }

  } id="copyAlarm">Copy Code</button></div>
                            <li>3. Open the Shortcuts app and import the downloaded Shortcut.</li>
                            <li>4. Run the Shortcut and paste the copied code.</li>
                            <li>5. Set the time you want to be woken up before school.</li>
                            <li>6. Go to the automation tab and set the shortcut to run at 12 am everyday.</li>
                            </ol>
   </div>
                    </div>
                </div>
            </div>
        </div>
    )

}